import { ReportRequestStatuses } from './report-request-statuses';
import { ReportRequestTypes } from './report-request-types';

export interface ReportRequestModel {
  id: string;
  dateRequested: Date;
  type: ReportRequestTypes;
  status: ReportRequestStatuses;
  reportSubjectId: string;
  contents: string[];
}
